/***** ################## API's Service Route's Defining ##################
 */

export const baseUrl = process.env.REACT_APP_baseUrl;

/**
 * ## Sub Routes Defining
 */

export const LOGIN = "/auth/admin/login";
export const CHANGE_PASSWORD = "/change-password/";
export const DASHBOARD = "/admin/dashboard";
export const DASHBOARD_TOP_ACHIEVERS = "/admin/dashboard/top-achievers";

export const REGION_LIST = "/regions/list";
export const REGION_LIST_DROPDOWN = "/regions/list/dropdown";
export const REGION_EDIT = "/region/edit/";
export const REGION_CREATE = "/region/create/";
export const REGION_UPDATE = "/region/update/";
export const REGION_DELETE = "/region/delete/";

export const COUNTRY_LIST = "/countrys/list";
export const COUNTRY_LIST_DROPDOWN = "/countrys/list/dropdown";
export const COUNTRY_EDIT = "/country/edit/";
export const COUNTRY_CREATE = "/country/create/";
export const COUNTRY_UPDATE = "/country/update/";
export const COUNTRY_DELETE = "/country/delete/";

export const STATE_LIST = "/states/list";
export const STATE_LIST_DROPDOWN = "/states/list/dropdown";
export const STATE_EDIT = "/state/edit/";
export const STATE_CREATE = "/state/create/";
export const STATE_UPDATE = "/state/update/";
export const STATE_DELETE = "/state/delete/";

export const USER_LIST = "/users/list";
export const USER_LIST_DROPDOWN = "/users/list/dropdown";
export const USER_EDIT = "/user/edit/";
export const USER_CREATE = "/user/create/";
export const USER_UPDATE = "/user/update/";
export const USER_DELETE = "/user/delete/";
export const USER_CHANGE_CHAPTER = "/user/change-chapter/";

export const COUNTRY_ADMIN_USER_LIST = "/country-admin-users/list";
export const COUNTRY_ADMIN_USER_EDIT = "/country-admin-user/edit/";
export const COUNTRY_ADMIN_USER_CREATE = "/country-admin-user/create/";
export const COUNTRY_ADMIN_USER_UPDATE = "/country-admin-user/update/";
export const COUNTRY_ADMIN_USER_DELETE = "/country-admin-user/delete/";

export const STATE_ADMIN_USER_LIST = "/state-admin-users/list";
export const STATE_ADMIN_USER_EDIT = "/state-admin-user/edit/";
export const STATE_ADMIN_USER_CREATE = "/state-admin-user/create/";
export const STATE_ADMIN_USER_UPDATE = "/state-admin-user/update/";
export const STATE_ADMIN_USER_DELETE = "/state-admin-user/delete/";

export const CHAPTER_ADMIN_USER_LIST = "/chapter-admin-users/list";
export const CHAPTER_ADMIN_USER_EDIT = "/chapter-admin-user/edit/";
export const CHAPTER_ADMIN_USER_CREATE = "/chapter-admin-user/create/";
export const CHAPTER_ADMIN_USER_UPDATE = "/chapter-admin-user/update/";
export const CHAPTER_ADMIN_USER_DELETE = "/chapter-admin-user/delete/";

export const REGION_ADMIN_USER_LIST = "/region-admin-users/list";
export const REGION_ADMIN_USER_EDIT = "/region-admin-user/edit/";
export const REGION_ADMIN_USER_CREATE = "/region-admin-user/create/";
export const REGION_ADMIN_USER_UPDATE = "/region-admin-user/update/";
export const REGION_ADMIN_USER_DELETE = "/region-admin-user/delete/";

export const CHAPTER_LIST = "/chapters/list";
export const CHAPTER_LIST_DROPDOWN = "/chapters/list/dropdown";
export const CHAPTER_EDIT = "/chapter/edit/";
export const CHAPTER_CREATE = "/chapter/create/";
export const CHAPTER_UPDATE = "/chapter/update/";
export const CHAPTER_DELETE = "/chapter/delete/";

export const USER_ROLE_LIST = "/user-roles/list";
export const USER_ROLE_LIST_DROPDOWN = "/user-roles/list/dropdown";
export const USER_ROLE_EDIT = "/user-role/edit/";
export const USER_ROLE_CREATE = "/user-role/create/";
export const USER_ROLE_UPDATE = "/user-role/update/";
export const USER_ROLE_DELETE = "/user-role/delete/";

export const CATEGORY_LIST = "/category/list";
export const CATEGORY_LIST_DROPDOWN = "/category/list/dropdown";
export const CATEGORY_EDIT = "/category/edit/";
export const CATEGORY_CREATE = "/category/create/";
export const CATEGORY_UPDATE = "/category/update/";
export const CATEGORY_DELETE = "/category/delete/";

export const BLOOD_GROUP_LIST = "/blood-groups/list";
export const BLOOD_GROUP_LIST_DROPDOWN = "/blood-groups/list/dropdown";
export const BLOOD_GROUP_EDIT = "/blood-group/edit/";
export const BLOOD_GROUP_CREATE = "/blood-group/create/";
export const BLOOD_GROUP_UPDATE = "/blood-group/update/";
export const BLOOD_GROUP_DELETE = "/blood-group/delete/";

export const INCOME_CATEGORY_LIST = "/income-category/list";
export const INCOME_CATEGORY_LIST_DROPDOWN = "/income-category/list/dropdown";
export const INCOME_CATEGORY_EDIT = "/income-category/edit/";
export const INCOME_CATEGORY_CREATE = "/income-category/create/";
export const INCOME_CATEGORY_UPDATE = "/income-category/update/";
export const INCOME_CATEGORY_DELETE = "/income-category/delete/";

export const EXPENSE_CATEGORY_LIST = "/expense-category/list";
export const EXPENSE_CATEGORY_LIST_DROPDOWN = "/expense-category/list/dropdown";
export const EXPENSE_CATEGORY_EDIT = "/expense-category/edit/";
export const EXPENSE_CATEGORY_CREATE = "/expense-category/create/";
export const EXPENSE_CATEGORY_UPDATE = "/expense-category/update/";
export const EXPENSE_CATEGORY_DELETE = "/expense-category/delete/";

export const POSTS_CATEGORY_LIST = "/posts-category/list";
export const POSTS_CATEGORY_LIST_DROPDOWN = "/posts-category/list/dropdown";
export const POSTS_CATEGORY_EDIT = "/posts-category/edit/";
export const POSTS_CATEGORY_CREATE = "/posts-category/create/";
export const POSTS_CATEGORY_UPDATE = "/posts-category/update/";
export const POSTS_CATEGORY_DELETE = "/posts-category/delete/";

export const SPONSORS_CATEGORY_LIST = "/sponsors-category/list";
export const SPONSORS_CATEGORY_LIST_DROPDOWN = "/sponsors-category/list/dropdown";
export const SPONSORS_CATEGORY_EDIT = "/sponsors-category/edit/";
export const SPONSORS_CATEGORY_CREATE = "/sponsors-category/create/";
export const SPONSORS_CATEGORY_UPDATE = "/sponsors-category/update/";
export const SPONSORS_CATEGORY_DELETE = "/sponsors-category/delete/";

export const FEED_POSTS_LIST = "/feed-posts/list";
export const FEED_POST_DELETE = "/feed-posts/delete/";
export const FEED_POST_STATUS_UPDATE = "/feed-posts/status/update/";
export const FEED_POST_COMMENTS = "/feed-posts/comments/";
export const FEED_POST_LIKES = "/feed-posts/likes/";

export const INCOMES_LIST = "/incomes/list";
export const INCOMES_CREATE = "/incomes/create";
export const INCOMES_EDIT = "/incomes/edit/";
export const INCOMES_UPDATE = "/incomes/update/";
export const INCOMES_DELETE = "/incomes/delete/";

export const EXPENSES_LIST = "/expenses/list";
export const EXPENSES_CREATE = "/expenses/create";
export const EXPENSES_EDIT = "/expenses/edit/";
export const EXPENSES_UPDATE = "/expenses/update/";
export const EXPENSES_DELETE = "/expenses/delete/";

export const SPONSORS_LIST = "/sponsors/list";
export const SPONSORS_CREATE = "/sponsors/create";
export const SPONSORS_EDIT = "/sponsors/edit/";
export const SPONSORS_UPDATE = "/sponsors/update/";
export const SPONSORS_DELETE = "/sponsors/delete/";

export const TIMER_LIST = "/timers/list";
export const TIMER_EDIT = "/timer/edit/";
export const TIMER_CREATE = "/timer/create/";
export const TIMER_UPDATE = "/timer/update/";
export const TIMER_DELETE = "/timer/delete/";

export const TIMER_ACCESS_GET = "/timer-access/get";
export const TIMER_ACCESS_UPDATE = "/timer-access/update";

export const CHAPTER_FINANCE_ACCESS_GET = "/chapter-finance-access/get";
export const CHAPTER_FINANCE_ACCESS_UPDATE = "/chapter-finance-access/update";

export const ROLE_LIST = "/roles/list";
export const ROLE_LIST_DROPDOWN = "/roles/list/dropdown";
export const ROLE_EDIT = "/role/edit/";
export const ROLE_CREATE = "/role/create/";
export const ROLE_UPDATE = "/role/update/";
export const ROLE_DELETE = "/role/delete/";
export const PERMISSION_LIST = "/permissions/list/";

export const MEMBER_CROWN_LIST_DROPDOWN = "/member-crowns/list/dropdown";

export const MEMBER_TYPE_LIST_DROPDOWN = "/member-types/list/dropdown";

export const CROWN_LIST = "/crowns/list";
export const CROWN_LIST_DROPDOWN = "/crowns/list/dropdown";
export const CROWN_EDIT = "/crown/edit/";
export const CROWN_CREATE = "/crown/create/";
export const CROWN_UPDATE = "/crown/update/";
export const CROWN_DELETE = "/crown/delete/";

export const TYFCB_LIST = "/tyfcbs/list";

export const MEETING_SCHEDULE_LIST = "/meetings/schedules/list";
export const MEETING_STATUS_UPDATE = "/meeting/status/update/";

export const ONE_TO_ONE_LIST = "/one-to-one/list";

export const REFERRAL_LIST = "/referrals/list";

export const VISITOR_LIST = "/visitors/list";
export const VISITOR_GENERAL_LIST = "/visitors/list";
export const VISITOR_CHIEF_GUEST_LIST = "/visitors/list";
export const VISITOR_POWER_DATE_LIST = "/visitors/list";
export const VISIT_STATUS_UPDATE = "/visit/status/update/";

export const WEEKLY_MEETINGS_LIST = "/weekly-meetings/list";
export const MEETING_EDIT = "/weekly-meeting/edit/";
export const MEETING_UPDATE = "/weekly-meeting/update/";
export const MEETING_CANCEL = "/weekly-meeting/cancel/";
export const MEETING_SCHEDULES_REGISTRY = "/weekly-meetings/schedules/registry/";
export const MEETING_SCHEDULES_REGISTRY_STATUS_UPDATE = "/weekly-meetings/schedules/registry/status/update/";
export const MEETING_FEES_REGISTRY = "/weekly-meetings/fees/registry/";
export const MEETING_FEES_REGISTRY_STATUS_UPDATE = "/weekly-meetings/fees/registry/status/update/";
export const FEES_EDIT = "/fees/edit/";
export const FEES_UPDATE = "/fees/update/";
export const WEEKLY_FEES_EDIT = "/weekly-fees/edit/";
export const WEEKLY_FEES_UPDATE = "/weekly-fees/update/";

export const MEETING_MONTHLY_FEES_LIST = "/meetings/monthly-fees/list";
export const MEETING_MONTHLY_FEES_STATUS_UPDATE = "/meeting/monthly-fees/status/update/";
export const MEETING_WEEKLY_FEES_LIST = "/meetings/fees/list";
export const MEETING_WEEKLY_FEES_STATUS_UPDATE = "/meeting/monthly-fees/status/update/";

export const EVENT_LIST = "/events/list";
export const EVENT_EDIT = "/event/edit/";
export const EVENT_CREATE = "/event/create/";
export const EVENT_UPDATE = "/event/update/";
export const EVENT_DELETE = "/event/delete/";

export const EVENT_REGISTRY = "/events/registry/";
export const EVENT_REGISTRY_STATUS_UPDATE = "/events/registry/status/update/";

export const NEWS_LIST = "/news/list";
export const NEWS_EDIT = "/news/edit/";
export const NEWS_CREATE = "/news/create/";
export const NEWS_UPDATE = "/news/update/";
export const NEWS_DELETE = "/news/delete/";

export const FORUM_SETTINGS_GET = "/forum-settings/get";
export const FORUM_SETTINGS_UPDATE = "/forum-settings/update";
export const FORUM_SETTINGS_PUBLIC = "/forum-settings/public";

export const MEMBER_MONTHLY_REPORTS_LIST = "/monthly-member-reports/list";
export const MEMBER_MONTHLY_REPORTS_GENERATE =
  "/monthly-member-reports/generate-last-month";
export const MEMBER_MONTHLY_REPORTS_GENERATE_MONTH =
  "/monthly-member-reports/generate-month";

export const MAP_OLD_WEEKLY_MEETING_FEES = "/meetings/map-old-weekly-meeting-fees";
export const MAP_OLD_BUSINESS_POINTS = "/points/map-old-business-points";

export const ATTENDANCE_QR_CODE_GET = "/attendance-qr-code/get";

export const TESTIMONIAL_LIST = "/testimonials/list";

export const POINTS_LIST = "/points/list";
export const POINTS_LOG_LIST = "/points-log/list";
export const POINTS_SYSTEM_LIST = "/points-system";
export const POINTS_SYSTEM_UPDATE = "/points-system/update/";

export const MEETING_SCHEDULE = "/meetings/schedule";

//reports
export const TYFCB_REPORTS_LIST = "/reports/tyfcbs/list";
export const BIZ_GIVEN_REPORTS_LIST = "/reports/biz-given/list";
export const ONE_TO_ONE_REPORTS_LIST = "/reports/one-to-one/list";
export const REFERRALS_REPORTS_LIST = "/reports/referrals/list";
export const VISITORS_REPORTS_LIST = "/reports/visitors/list";
export const VISITORS_GENERAL_REPORTS_LIST = "/reports/visitors-general/list";
export const VISITORS_CHIEF_GUEST_REPORTS_LIST = "/reports/visitors-chief-guest/list";
export const VISITORS_INDUCTION_REPORTS_LIST = "/reports/visitors-inductions/list";
export const VISITORS_POWER_DATE_REPORTS_LIST = "/reports/visitors-power-date/list";
export const FEES_REPORTS_LIST = "/reports/fees/list";
export const ATTENDANCE_REPORTS_LIST = "/reports/attendance/list";
export const OVERALL_REPORTS_LIST = "/reports/overall/list";
export const LEDGER_REPORTS_LIST = "/reports/ledgers/list";
export const MEMBERSHIP_EXPIRY_AND_RENEWAL_REPORTS_LIST = "/reports/membership-expiry-and-renewals/list";
export const CHAPTER_WISE_BUSINESS_REPORTS_LIST = "/reports/chapter-wise-business/list";
export const CHAPTER_WISE_ONE_TO_ONE_REPORTS_LIST = "/reports/chapter-wise-one-to-one/list";
export const CHAPTER_WISE_REFERRALS_REPORTS_LIST = "/reports/chapter-wise-referrals/list";
export const CHAPTER_WISE_VISITORS_REPORTS_LIST = "/reports/chapter-wise-visitors/list";